<template>
  <div class="quotes-list-filters-fields">
    <app-equipment-types-checkbox v-model="value.equipmentTypes"></app-equipment-types-checkbox>
    <app-packaging-types-checkbox v-model="value.packagingTypes"></app-packaging-types-checkbox>
    <app-pickup-regions-select v-model="value.pickupRegions"></app-pickup-regions-select>
    <app-delivery-regions-select v-model="value.deliveryRegions"></app-delivery-regions-select>
    <el-form-item :label="$t('QUOTES_LIST_FILTERS_FIELDS.TITLE')">
      <el-switch :active-text="$t('QUOTES_LIST_FILTERS_FIELDS.RESPONDED.TITLE')"
                 :active-value="true"
                 v-model="value.responded">
      </el-switch>
      <br/>
      <el-switch :active-text="$t('QUOTES_LIST_FILTERS_FIELDS.MANAGEABLE.TITLE')"
                 :active-value="true"
                 v-model="value.manageable">
      </el-switch>
    </el-form-item>
  </div>
</template>

<script>
import AppDeliveryRegionsSelect from '@/components/delivery-regions-select/DeliveryRegionsSelect'
import AppEquipmentTypesCheckbox from '@/components/equipment-types-checkbox/EquipmentTypesCheckbox'
import AppPackagingTypesCheckbox from '@/components/packaging-types-checkbox/PackagingTypesCheckbox'
import AppPickupRegionsSelect from '@/components/pickup-regions-select/PickupRegionsSelect'

export default {
  name: 'QuotesListFiltersFields',
  components: {
    AppDeliveryRegionsSelect,
    AppPickupRegionsSelect,
    AppPackagingTypesCheckbox,
    AppEquipmentTypesCheckbox
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>
